export default '/src/assets/webgl/francesca_1/audios/en/bundle_1.mp3'